// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var I18n = /** @class */ (function () {
    function I18n(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(I18n.prototype, "lang", {
        /**
         * i18n_lang 参数
         */
        get: function () {
            var i18n_lang = this.adapter.getStore().i18n_lang;
            return i18n_lang;
        },
        enumerable: false,
        configurable: true
    });
    return I18n;
}());
export { I18n };
